import { useState } from 'react'
import Modal from '..'
import ModalClose from '../ModalClose'
import { IRemoveStaffModal } from '../../../interfaces/staff'
import { IoWarningOutline } from 'react-icons/io5'
import { showToast } from '../../../utils/toast'
import StaffService from '../../../api/staff-service'

const RemoveStaffModal = ({
  open,
  setIsOpen,
  loading,
  setloading,
  staffId,
  reload,
}: IRemoveStaffModal   ) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleRemoveClick = async () => {
    if (isLoading) return;

    if (!staffId) {
      return;
    }
  
    setIsLoading(true);
    try {
      const response = await StaffService.deleteStaffById(staffId);

      const isSuccess =
      response?.success === true ||
      response?.message?.toLowerCase().includes('staff removed from estate successfully');
    
  
      if (isSuccess) {
        showToast({
          title: 'Staff removed from estate successfully',
          status: 'success',
          id: 'remove-staff-success',
        });

        
        setIsOpen(false);
        setTimeout(() => {
          reload();
        }, 200);
      } else {
        showToast({
          title: response?.message || 'Failed to remove staff. Please try again.',
          status: 'error',
          id: 'remove-staff-fail',
        });
      }
    } catch (err: any) {
      showToast({
        title: err?.response?.data?.message || 'Failed to remove staff. Please try again.',
        status: 'error',
        id: 'remove-staff-error',
      });
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <Modal
    open={open}
    close={() => !isLoading && setIsOpen(false)}
    widthClass="w-[calc(100%-32px)] sm:max-w-md md:max-w-lg"
    >    <ModalClose onClick={() => setIsOpen(false)} />
    <div className="flex flex-col items-center text-center">
      <IoWarningOutline className="text-red-600 text-5xl sm:text-6xl" />
      <h2 className="text-lg sm:text-2xl font-semibold mb-4 text-red-600">Remove Staff</h2>
    </div>
    <div className="text-xs sm:text-sm text-gray-600 text-center px-2">
      Are you sure you want to remove this staff member? This action cannot be undone.
    </div>
    <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 sm:gap-4 mt-8 sm:mt-10">
      <button
        onClick={() => setIsOpen(false)}
        disabled={isLoading}
        className="w-full sm:w-auto border border-gray-300 rounded-md px-4 py-2 text-xs sm:text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:shadow-none enabled:hover:bg-gray-100"
      >
        Cancel
      </button>
      <button
        onClick={handleRemoveClick}
        disabled={isLoading}
        className="w-full sm:w-auto bg-red-600 text-white rounded-md px-4 py-2 text-xs sm:text-sm transition-colors disabled:cursor-not-allowed disabled:opacity-100 disabled:transform-none disabled:shadow-none disabled:bg-red-300 enabled:hover:bg-red-700"
      >
        {isLoading ? 'Removing...' : 'Remove'}
      </button>
    </div>
  </Modal>
  
  )
}

export default RemoveStaffModal
